import Keycloak from "keycloak-js";
import { APIProvider } from "Providers/APIProvider";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { VIVA_AUTH_CLIENTID, VIVA_AUTH_REALM, VIVA_AUTH_URL } from "./Props";
import reportWebVitals from "./reportWebVitals";

const keycloak = Keycloak({
  url: VIVA_AUTH_URL,
  realm: VIVA_AUTH_REALM,
  clientId: VIVA_AUTH_CLIENTID,
});

keycloak.init({ onLoad: "login-required" }).then((authenticated) => {
  if (!authenticated) {
    window.location.reload();
  } else {
    if (keycloak.token) {
      sessionStorage.setItem("authentication", keycloak.token);
      ReactDOM.render(
        <React.StrictMode>
          <APIProvider keycloak={keycloak}>
            <App />
          </APIProvider>
        </React.StrictMode>,
        document.getElementById("root")
      );
    }
    setTimeout(() => {
      keycloak.updateToken(5).catch(() => {
        console.error("Failed to refresh token");
      });
    }, 60000);
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
